module.exports = __webpack_public_path__ + "img/maropost-marketing-cloud.42df23ac.svg";